import { useTranslation } from 'react-i18next';

export const Footer = (props) => {
  const { t } = useTranslation();

  return (
    <footer id='footer' style={{ backgroundColor: '#171e24' }}>
      <div className='container text-center'>
        <nav aria-label="Footer navigation" style={{ marginBottom: '10px' }}>
          <a href="https://play.google.com/store/apps/details?id=com.proto.circuitsimulator"
             target="_blank" rel="noopener noreferrer" style={{ color: '#ffd451' }}>Google Play</a>
          {' | '}
          <a href="/privacy-policy.html" style={{ color: '#ffd451' }}>{t('Footer.privacyPolicy')}</a>
          {' | '}
          <a href="mailto:proto.playstore@gmail.com" style={{ color: '#ffd451' }}>{t('Footer.contact')}</a>
        </nav>
        <p style={{ color: '#888', fontSize: '14px' }}>
          &copy; 2026 PROTO
        </p>
      </div>
    </footer>
  )
}
